'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _recompose = require('recompose');

var _elementHelper = require('../../../../../common/elements/elementHelper');

var _elementFilterUtil = require('../../../../element/elementFilter/elementFilterUtil');

var _stringUtil = require('../../../../../common/utils/stringUtil');

var _notificationUtils = require('../../../../../common/notifications/notificationUtils');

var _boardSelector = require('../../../../element/board/boardSelector');

var _Icon = require('../../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _PillButton = require('../../../../components/buttons/PillButton');

var _PillButton2 = _interopRequireDefault(_PillButton);

var _navigationActions = require('../../../../reducers/navigationActions');

require('./ElementFilterUtil.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Actions


// Components
// Lib
var FILTER_TYPES = {
    ELEMENT: 'ELEMENT',
    DATE: 'DATE'
};

// Styles


// Selectors


// Utils


var activeElementSelector = (0, _reselect.createSelector)(function (state, ownProps) {
    return ownProps.elementFilter;
}, function (state) {
    return state.get('elements');
}, function (state, ownProps) {
    return ownProps.currentBoardId;
}, function (elementFilter, elements, currentBoardId) {
    if (!elementFilter) return null;

    var children = (0, _elementHelper.getChildrenDeep)(elements, currentBoardId);

    return children.filter(function (element) {
        return (0, _elementFilterUtil.filterElement)(element, elementFilter);
    });
});

var elementFilterTypeSelector = (0, _reselect.createSelector)(function (state, ownProps) {
    return ownProps.elementFilter;
}, function (elementFilter) {
    return elementFilter && elementFilter.ids ? FILTER_TYPES.ELEMENT : FILTER_TYPES.DATE;
});

var elementFilterUtilSelector = (0, _reselect.createSelector)(function (state, ownProps) {
    return ownProps.elementFilter;
}, activeElementSelector, _boardSelector.getIsCurrentBoardFetched, elementFilterTypeSelector, function (elementFilter, activeElements, currentBoardFetched, filterType) {
    return {
        active: currentBoardFetched && elementFilter !== null,
        activeElements: activeElements,
        filterCount: activeElements && activeElements.size,
        filterType: filterType
    };
});

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchClearFilter: function dispatchClearFilter() {
            return dispatch((0, _navigationActions.clearFilter)());
        }
    };
};

var lifecyleEvents = {
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        var active = nextProps.active,
            filterCount = nextProps.filterCount,
            dispatchClearFilter = nextProps.dispatchClearFilter;

        if (active && filterCount === 0) dispatchClearFilter();
    }
};

var ElementFilterRecent = function ElementFilterRecent(_ref) {
    var filterCount = _ref.filterCount;
    return _react2.default.createElement(
        'span',
        { className: 'changes' },
        _react2.default.createElement(
            'span',
            { className: 'verb' },
            'Showing'
        ),
        _react2.default.createElement(
            'span',
            { className: 'query' },
            ' ',
            filterCount,
            ' recent ',
            (0, _stringUtil.pluralise)('change', filterCount)
        )
    );
};

ElementFilterRecent.propTypes = {
    filterCount: _propTypes2.default.number
};

var ElementFilterDescribe = function ElementFilterDescribe(_ref2) {
    var activeElements = _ref2.activeElements;

    var elementsJs = activeElements.toJS();
    var elements = Object.keys(elementsJs).map(function (key) {
        return elementsJs[key];
    }).reduce(_notificationUtils.reduceTypeCounts, {});

    return _react2.default.createElement(
        'span',
        { className: 'changes' },
        _react2.default.createElement(
            'span',
            { className: 'verb' },
            'Showing'
        ),
        _react2.default.createElement(
            'span',
            { className: 'query' },
            ' ',
            (0, _notificationUtils.describeElementTypes)(elements)
        )
    );
};

ElementFilterDescribe.propTypes = {
    activeElements: _propTypes2.default.object
};

var ElementFilterUtil = function ElementFilterUtil(props) {
    var active = props.active,
        filterType = props.filterType,
        dispatchClearFilter = props.dispatchClearFilter;


    if (!active) return null;

    return _react2.default.createElement(
        _PillButton2.default,
        { className: 'ElementFilterUtil', onClickFn: dispatchClearFilter },
        filterType === FILTER_TYPES.DATE ? _react2.default.createElement(ElementFilterRecent, props) : _react2.default.createElement(ElementFilterDescribe, props),
        _react2.default.createElement(
            'span',
            { className: 'close' },
            _react2.default.createElement(_Icon2.default, { name: 'close-x-small' })
        )
    );
};

ElementFilterUtil.propTypes = {
    active: _propTypes2.default.bool,
    dispatchClearFilter: _propTypes2.default.func,
    activeElements: _propTypes2.default.object,
    filterCount: _propTypes2.default.number,
    filterType: _propTypes2.default.string
};

var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(elementFilterUtilSelector, mapDispatchToProps), (0, _recompose.lifecycle)(lifecyleEvents), _recompose.pure);

exports.default = enhance(ElementFilterUtil);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/elementFilter/ElementFilterUtil.js
// module id = 778
// module chunks = 0